import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNow, parseISO } from 'date-fns';

@Pipe({
    standalone: true,
    name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {

    transform(value: string | Date): string {
        let date: Date;
        typeof value === 'string' ? date = parseISO(value) : date = value;

        return formatDistanceToNow(date, { addSuffix: true });
      }
}
